"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
class ProductStore {
    constructor(config) {
        this.enable = config && config.list.length > 0;
        this.items = config.list;
        this.total = config.total;
        this.isCoupon = config.isCoupon;
        this.couponImage = config.couponImage;
        this.couponUrl = config.couponUrl;
    }
}
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Boolean)
], ProductStore.prototype, "enable", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Array)
], ProductStore.prototype, "items", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Number)
], ProductStore.prototype, "total", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Boolean)
], ProductStore.prototype, "isCoupon", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", String)
], ProductStore.prototype, "couponImage", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", String)
], ProductStore.prototype, "couponUrl", void 0);
exports.default = ProductStore;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZHVjdFN0b3JlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicHJvZHVjdFN0b3JlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLCtCQUFrQztBQVdsQyxNQUFxQixZQUFZO0lBTy9CLFlBQVksTUFBcUI7UUFDL0IsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLElBQUksTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFDO1FBQy9DLElBQUksQ0FBQyxLQUFLLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQztRQUN6QixJQUFJLENBQUMsS0FBSyxHQUFHLE1BQU0sQ0FBQyxLQUFLLENBQUM7UUFDMUIsSUFBSSxDQUFDLFFBQVEsR0FBRyxNQUFNLENBQUMsUUFBUSxDQUFDO1FBQ2hDLElBQUksQ0FBQyxXQUFXLEdBQUcsTUFBTSxDQUFDLFdBQVcsQ0FBQztRQUN0QyxJQUFJLENBQUMsU0FBUyxHQUFHLE1BQU0sQ0FBQyxTQUFTLENBQUM7SUFDcEMsQ0FBQztDQUNGO0FBZGE7SUFBWCxpQkFBVTs7NENBQXdCO0FBQ3ZCO0lBQVgsaUJBQVU7OzJDQUE4QjtBQUM3QjtJQUFYLGlCQUFVOzsyQ0FBc0I7QUFDckI7SUFBWCxpQkFBVTs7OENBQTBCO0FBQ3pCO0lBQVgsaUJBQVU7O2lEQUE0QjtBQUMzQjtJQUFYLGlCQUFVOzsrQ0FBMEI7QUFOdkMsK0JBZUMifQ==